import { palette } from 'c1ui'
import { moduleStyleType } from 'components/no-ui/styles/styleTypes'

export const styles: moduleStyleType = {
    relativeText: {
        '&:hover': {
            backgroundColor: palette.grey[100],
        },
    },
    tooltipText: {
        backgroundColor: palette.grey[100],
        color: palette.text.primary,
    },
    overdue: {
        color: palette.error.main,
    },
    icon: {
        fontSize: 16,
        display: 'block',
        ml: 0,
    },
    error: {
        color: palette.error.dark,
    },
}
